import { render, staticRenderFns } from "./StageDetails.vue?vue&type=template&id=83bbb39c&"
import script from "./StageDetails.vue?vue&type=script&lang=js&"
export * from "./StageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports